import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["apiKey", "status", "form", "closeButton", "oauthButton", "edit", "clear", "label"]

  connect() {
    this.updateState()
  }

  updateButtonLabel() {
    this.closeButtonTarget.textContent = this.apiKeyTarget.value ? "Save" : "Close"
  }

  updateState() {
    this.#updateLabel()

    if (this.#isFilled()) {
      this.close()
    } else {
      this.edit()
    }
  }

  close() {
    const isFilled = this.#isFilled()

    this.statusTarget.textContent = isFilled ? "Filled" : "Empty"
    this.statusTarget.classList.toggle("filled", isFilled)
    this.statusTarget.classList.toggle("empty", !isFilled)

    // Hide “close” or “Get token” buttons
    this.closeButtonTarget.setAttribute("aria-hidden", true)
    this.oauthButtonTarget.setAttribute("aria-hidden", true)
    // Hide form
    this.formTarget.setAttribute("aria-hidden", true)

    // Display status
    this.statusTarget.setAttribute("aria-hidden", false)

    // Display action button
    const isAutoOauth2 = this.#isAutoOauth2()
    // --- Two different action based on scheme type
    this.editTarget.setAttribute("aria-hidden", isAutoOauth2)
    this.clearTarget.setAttribute("aria-hidden", !isAutoOauth2)

    this.closeButtonTarget.textContent = "Close"
  }

  clear() {
    // 1. clear api key field value
    this.apiKeyTarget.value = ""
    // 2. Simulate user input for other events to bubble up (store key in
    // local storage, update UI, etc..)
    this.apiKeyTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.edit()
  }

  edit() {
    // Display form
    this.formTarget.setAttribute("aria-hidden", false)

    const isAutoOauth2 = this.#isAutoOauth2()
    // Different state based on security scheme type
    this.apiKeyTarget.hidden = isAutoOauth2

    // Show action button
    this.closeButtonTarget.setAttribute("aria-hidden", isAutoOauth2)
    this.oauthButtonTarget.setAttribute("aria-hidden", !isAutoOauth2)

    // Hide status
    this.statusTarget.setAttribute("aria-hidden", true)

    // Hide action buttons
    this.editTarget.setAttribute("aria-hidden", true)
    this.clearTarget.setAttribute("aria-hidden", true)
  }

  highlightForm() {
    this.element.dataset.formHighlight = true

    setTimeout(() => {
      delete this.element.dataset.formHighlight
    }, 1000)
  }

  #isFilled() {
    const apiKey = this.apiKeyTarget.value.trim()
    return apiKey.length > 0
  }

  #isAutoOauth2() {
    const authenticationScheme = this.#selectedAuthenticationScheme()

    if (authenticationScheme) {
      return !!(authenticationScheme.dataset.oauth?.grantType || JSON.parse(authenticationScheme.dataset.oauth)?.grantType)
    } else {
      return false
    }
  }

  #selectedAuthenticationScheme() {
    return this.element.querySelector("[data-selected-scheme=true]")
  }

  #updateLabel() {
    if (this.hasLabelTarget) {
      this.labelTarget.innerText = this.#selectedAuthenticationScheme().dataset.schemeLabel || ""
    }
  }
}
